/**
 * Created by Ram on 21/03/2017.
 */

import React, { Component } from "react";
import ClustersList from './ClusterManagement/ClustersList'

class ClusterManagement extends Component {
  render() {
    let clusterListMessage;
    let arrowDevices = null;

    const { clusters, currentCluster, sortAsc, sort } = this.props.loadData
    const { updateSortState, getClusterDevices, getClusterDetails, deleteCluster } = this.props

 
    if (this.props.loadData.sortDevicesAsc) {
      arrowDevices = (
        <span className="glyphicon glyphicon-triangle-bottom" title="Active" />
      );
    } else {
      arrowDevices = (
        <span className="glyphicon glyphicon-triangle-top" title="Inactive" />
      );
    }

    let clusterDevices = this.props.loadData.devices.map(clusterDevice => {
      return (
        <tr
          key={clusterDevice._id}
          className={clusterDevice.trackingDevice === true ? "tracking-device-color" : ""}
        >
          <td>{clusterDevice.name}</td>
          <td>{clusterDevice.model}</td>
          <td>{clusterDevice.osVersion}</td>
        </tr>
      );
    });

    let commentsBox;
    if (this.props.loadData.clusterComments.length) {
      commentsBox = (
        <div className="comments-box">
          <span className="comments-box-heading">Comments</span>
          {this.props.loadData.clusterComments}
        </div>
      );
    }

    return (
      <div>
        <ol className="breadcrumb">
          <li>
            <a onClick={this.props.navigator.requestDeviceManagement}>
              Device Management
            </a>
          </li>
          <li className="active">Cluster Management</li>
        </ol>

        <div className="cluster-management-main-div pull-left">
          <div className="search-cluster-list">
            <div className="row">
              <div className="col-sm-4">
                <span className="block-heading">
                  <span className="glyphicon glyphicon-th" /> Clusters
                </span>
              </div>
              <div className="col-sm-3 shift-left">
                <button
                  type="button"
                  className="btn btn-add pull-right"
                  onClick={this.props.navigator.requestCreateCluster}
                >
                  <span className="glyphicon glyphicon-plus" /> New
                </button>
              </div>
              <div className="col-sm-1">
                <button
                  type="button"
                  className="btn btn-info pull-right"
                  onClick={this.props.navigator.requestDeviceManagement}
                >
                  <span className="glyphicon glyphicon-chevron-left" /> Devices
                </button>
              </div>
              <div className="col-sm-4">
                <input
                  type="search"
                  placeholder="Search..."
                  className="form-control cluster-search"
                  onChange={this.props.updateSearchState}
                  value={this.props.loadData.search}
                />
              </div>
            </div>
          </div>

          <div className="cluster-management-list">
                <ClustersList 
                  clusters={clusters}
                  onClick={getClusterDevices}
                  onSort={updateSortState}
                  onEdit={getClusterDetails}
                  onDelete={deleteCluster}
                  selectedCluster={currentCluster}
                  isSortAsc={sortAsc}
                  sortBy={sort}
                />
            {clusterListMessage}
          </div>
        </div>

        <div className="cluster-management-overview pull-right">
          <div className="cluster-management-devices-list">
            <span>Cluster name: {this.props.loadData.clusterName}</span>

            {commentsBox}

            <table className="table table-striped">
              <thead>
                <tr>
                  <th
                    onClick={this.props.updateDevicesSortState.bind(
                      null,
                      "name"
                    )}
                  >
                    <span>Device name</span>{" "}
                    {this.props.loadData.sortDevices === "name"
                      ? arrowDevices
                      : ""}
                  </th>
                  <th
                    onClick={this.props.updateDevicesSortState.bind(
                      null,
                      "model"
                    )}
                  >
                    <span>Model </span>
                    {this.props.loadData.sortDevices === "model"
                      ? arrowDevices
                      : ""}
                  </th>
                  <th
                    onClick={this.props.updateDevicesSortState.bind(
                      null,
                      "osVersion"
                    )}
                  >
                    <span>OS Version </span>
                    {this.props.loadData.sortDevices === "osVersion"
                      ? arrowDevices
                      : ""}
                  </th>
                </tr>
              </thead>
              <tbody>{clusterDevices}</tbody>
            </table>
          </div>
        </div>
      </div>
    ); // return
  } // render
} // ClusterManagement

export default ClusterManagement;
